<template>
  <MaskLayer>
    <Slider class="w-75" @close="close">
      <div class="container-fluid p-0 mw-100 flex-grow-1 overflow-auto">
        <div class="h-100 overflow-auto row no-gutters">
          <div class="col-3 h-100 overflow-auto border border-right border-light">
            <div class="w-100 d-flex align-items-center flex-column px-3 my-2">
              <div class="my-2 image-panel image-panel-3 rounded rounded-circle">
                <template>
                  <img v-if="user.userAvatar" :src="user.userAvatar" @error="onAvatarError">
                  <img v-else src="@/assets/images/default-avatar.png">
                </template>
              </div>
              <h6 class="my-1">
                {{ user.userName }}
              </h6>
              <div class="my-1 font-size-md">
                {{ user.email }}
              </div>
              <div class="my-1 font-size-md">
                {{ user.roles && user.roles[0] ? user.roles[0].name : '' }}
              </div>
              <b-form-checkbox v-model="status" size="sm" name="check-button" switch class="text-primary">
                <template v-if="user.status === 0">
                  {{ $t('auth.disabled') }}
                </template>
                <template v-else-if="user.status === 1">
                  {{ $t('auth.activating') }}
                </template>
                <template v-else-if="user.status === 2">
                  {{ $t('auth.inviting') }}
                </template>
              </b-form-checkbox>
            </div>
            <!-- 選單-一致款式 begin -->
            <div class="px-3">
              <b-button variant="outline-light" class="w-100 py-0 mb-2 d-flex align-items-center text-secondary position-relative" draggable="">
                <div class="image-panel image-panel-0 bg-none">
                  <span class="material-icons-outlined md-18">person</span>
                </div>
                <span class="font-size-md text-truncate">{{ $t('auth.userSetting.personalInfo') }}</span>
              </b-button>
              <!-- <b-button variant="light" class="w-100 py-0 mb-2 d-flex align-items-center text-secondary position-relative" draggable="">
                <div class="image-panel image-panel-0 bg-none"><span class="material-icons-outlined md-18">vpn_key</span></div>
                <span class="font-size-md text-truncate">變更密碼</span>
              </b-button> -->
            </div>
            <!-- 選單-一致款式 end -->
          </div>
          <!-- 內容 begin -->
          <div class="col-9 p-4 h-100 overflow-auto">
            <div class="w-75 m-auto d-flex flex-column">
              <div class="m-auto d-inline-block position-relative">
                <a href="#" class="image-panel image-panel-5 rounded rounded-circle">
                  <template>
                    <img v-if="user.userAvatar" :src="user.userAvatar" @error="onAvatarError">
                    <img v-else src="@/assets/images/default-avatar.png">
                  </template>
                </a>
              </div>
              <div class="my-1">
                <h6 class="font-size-md">
                  {{ $t('auth.userSetting.form.name') }}
                </h6>
                <p>{{ user.userName }}</p>
              </div>
              <div class="my-1">
                <h6 class="font-size-md">
                  E-mail
                </h6>
                <p>{{ user.email }}</p>
              </div>
              <div class="my-1">
                <h6 class="font-size-md">
                  {{ $t('auth.userSetting.form.mobile') }}
                </h6>
                <p>{{ user.userMobile }}</p>
              </div>
              <div class="my-3">
                <h6 class="font-size-md">
                  <span class="flex-grow-1">{{ $t('auth.userSetting.form.roles') }}</span>
                </h6>
                <b-form-select
                  v-model="roleId"
                  :options="roles"
                  size="sm"
                  class="w-100 rounded-pill"
                  @input="onRoleChange"
                />
                <div class="px-2 mx-3 my-3 text-primary border-left border-light">
                  <template v-for="feature in features">
                    <div :key="feature.id" class="font-size-sm mb-4">
                      <h6 class="font-size-md mb-1">
                        {{ $t(`features.${feature.id}`) }}
                      </h6>
                      <ul v-if="feature.children && feature.children.length > 0" class="pl-4">
                        <template v-for="sub in feature.children">
                          <li :key="sub.id">
                            <b>{{ $t(`features.${sub.id}`) }}</b>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- 內容 end -->
        </div>
      </div>
      <!-- 置底按鈕 begin -->
      <FixedBottomBtn class="bg-white p-3">
        <div class="d-flex justify-content-between">
          <div>
            <button v-auth="['delete']" style="display: none;" class="ml-2 btn btn-sm btn-outline-light rounded-pill border-0 d-flex align-items-center" @click="del">
              <span class="text-secondary material-icons-outlined md-18 mr-1">delete</span>
              <span class="text-secondary">{{ $t('common.delete' ) }}</span>
            </button>
          </div>
          <div>
            <button class="ml-2 btn btn-sm btn-outline-light rounded-pill" @click="close">
              <span class="px-3 text-secondary">{{ $t('common.cancel') }}</span>
            </button>
            <button v-auth="['edit']" class="ml-2 btn btn-sm btn-success rounded-pill" @click="save">
              <span class="px-3">{{ $t('common.save') }}</span>
            </button>
          </div>
        </div>
      </FixedBottomBtn>
    </Slider>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import Slider from '@/components/Slider.vue';
import FixedBottomBtn from '@/components/FixedBottomBtn.vue';
import PermissionService from '@/services/PermissionService';
import defaultAvatar from '@/assets/images/default-avatar.png';

export default {
  components: {
    MaskLayer,
    Slider,
    FixedBottomBtn
  },
  props: ['userId'],
  data() {
    return {
      user: {},
      status: false,
      showDeleteConfirm: false,
      roles: [],
      roleId: null,
      features: []
    };
  },
  async created() {
    const vm = this;
    await vm.$loading(async () => {
      vm.user = await PermissionService.GetCompanyUserProfileAsync(vm.userId);
      vm.status = vm.user.status === 1 || vm.user.status === 2;
      vm.roleId = vm.user.roles && vm.user.roles[0] ? vm.user.roles[0].id : null;
      vm.$watch('status', () => {
        vm.user.status = vm.status ? 1 : 0;
      });

      const result = await PermissionService.GetRolesAsync(null, 1000, 0);
      if (result && result.data) {
        vm.roles = result.data.map((item) => ({ value: item.id, text: `${item.name}${item.desc ? `(${item.desc})` : ''}` }));
      }
    });
  },
  methods: {
    // 角色選項變更事件
    async onRoleChange(roleId) {
      this.features = await PermissionService.GetRoleFeaturesAsync(roleId);
    },
    onAvatarError(e) {
      e.target.src = defaultAvatar;
    },
    // 關閉
    close() {
      this.$emit('close');
    },
    // 確認
    confirm() {
      this.$emit('confirm');
    },
    // 刪除
    async del() {
      const message = this.$t('auth.userSetting.confirmDelete');
      const confirmed = await this.$popup.confirmAsync(message);

      if (confirmed) {
        this.deleteUser();
      }
    },
    // 確認刪除
    async deleteUser() {
      await PermissionService.DeleteCompanyUserAsync(this.user.userId);
      this.showDeleteConfirm = false;
      this.confirm();
    },
    // 儲存
    async save() {
      const vm = this;
      const user = {
        id: vm.user.userId,
        status: vm.user.status ? 1 : 0,
        roleIds: [vm.roleId]
      };

      try {
        await vm.$loading(async () => {
          await PermissionService.UpdateCompanyUserAsync(user);
        });
        vm.$notify.saveSuccess();
        vm.$emit('confirm');
        // 重新整理頁面已取得新的功能設置
        vm.$router.go(0);
      } catch {
        vm.$notify.saveFailed();
      }
    }
  }
};
</script>
